import { createIntl } from "react-intl";
import { allMessages } from ".";

export function Translate(id) {
  let locale = localStorage.getItem("language");
  if (!locale) locale = "en";
  const intl = createIntl({ locale, messages: allMessages });
  return intl.messages[locale][id];
}
